import type { CloudGraphConversationEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI: CloudGraphConversationEntityAti[] = [
	'ati:cloud:graph:conversation',
];
